module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.51c6f51c.png";